import React from 'react';
import { Button, Box, DialogActions, DialogContentText } from '@mui/material';
import BaseDialog from '../../Common/BaseDialog';


interface ConfirmRevokeProps {
    closeDialog: any;
    revoke: any;
}
export default function ConfirmRevoke(props: ConfirmRevokeProps) {
    return (
        <BaseDialog
            open={true}
            header="Are you sure you want to revoke?"
            showCloseIcon={true}
            showCloseButton={false}
            onClose={() => props.closeDialog()}
        >
            <Box
                sx={{
                    minHeight: 150,
                    display: "flex",
                    alignItems: "center"
                }}>
                <Box sx={{
                    width: "100%"
                }}>
                    <DialogContentText>
                        Revoking users cannot be undone! Once complete, all deprovisioned data will be entirely removed from the system, with no way to revert.
                        If used improperly, the reports that customers see will not be accurate. Are you sure you want to continue?
                    </DialogContentText>
                    <DialogActions>
                        <Button
                            onClick={() => props.revoke()}
                            variant="contained"
                            color="secondary"
                        >
                            Revoke Provisioning
                        </Button>
                        <Button
                            onClick={() => props.closeDialog()}
                            variant="contained"
                        >
                            Cancel
                        </Button>
                    </DialogActions>
                </Box>
            </Box>
        </BaseDialog>
    );
}